import { Component } from '@angular/core';
import {ButtonIconComponent} from "../../ui/button-icon/button-icon.component";
import {AsyncPipe, NgForOf, NgIf} from "@angular/common";
import {LocaleService} from "../../../services/locale.service";
import {SharedModule} from "../../../shared/shared.module";
import {TranslateModule} from "@ngx-translate/core";
import {Locale} from "../../../enum/locale";

@Component({
  selector: 'app-language-selector',
  standalone: true,
  imports: [
    ButtonIconComponent,
    AsyncPipe,
    SharedModule,
    TranslateModule,
    NgIf,
    NgForOf
  ],
  templateUrl: './language-selector.component.html',
  styleUrl: './language-selector.component.scss'
})
export class LanguageSelectorComponent {
  show = false;
  currentLocale$ = this.localeService.localeChanged$;

  constructor(private localeService: LocaleService) {
  }

  get languages() {
    return Object.values(Locale);
  }

  isActive(locale: Locale | string) {
    return this.localeService.currentLocale === locale;
  }

  select(locale: Locale | string) {
    this.localeService.updateLocale(locale as Locale);
    this.show = false;
  }

  toggle() {
    this.show = !this.show;
  }
}
